<app-header></app-header>
<div class=" text-light  align-items-center" style=" height: 100vh; background-color: black;">

    <div class="container ">
        <div *ngFor="let prod of Products">
            <a [routerLink]="['/Product', prod.Name]">
                <div class=" d-flex d-sm-block justify-content-center">
                    <div class="d-sm-flex align-items-center justify-content-between p-3">
                        <img [src]="prod.icon" alt="" width="100" height="100">
                        <h6> {{prod.Name}} </h6>
                        <a [href]="prod.DownloadLink">
                            <button class="btn btn-primary">Download</button>
                        </a>
                    </div>
                    <hr>
                </div>
            </a>


        </div>
    </div>
</div>


<app-footer></app-footer>